import React, { useEffect, useState } from 'react';
import { apiCall } from '../utils/apiService';

const WebhookSettingLayer = () => {
    const [alertMessage, setAlertMessage] = useState('');
    const [spinner, setSpinner] = useState(false);
    const [facebookWebhook, setFacebookWebhook] = useState({
        type: 'facebook',
        access_token: '',
        page_access_token: '',
        app_id: '',
    });
    const [instagramWebhook, setInstagramWebhook] = useState({
        type: 'instagram',
        access_token: '',
        page_access_token: '',
        app_id: '',
    });

    const fetchWebookData = async () => {
        try {
            const response = await apiCall({
                url: `webhook/get-config`,
                method: 'GET',
            });
            if (response) {
                setFacebookWebhook(prevState => ({
                    ...prevState,
                    ...response.data.facebook
                }));
                setInstagramWebhook(prevState => ({
                    ...prevState,
                    ...response.data.instagram
                }));
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const syncInstagramConversationList = async () => {
        try {
            const response = await apiCall({
                url: `social/sync-ig-conversation-list`,
                method: 'GET',
            });
            if (response) {
                console.log(response)
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const syncFacebookConversationList = async () => {
        try {
            const response = await apiCall({
                url: `social/sync-fb-conversation-list`,
                method: 'GET',
            });
            if (response) {
                console.log(response)
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const handleFacebookSubmit = async (e) => {
        e.preventDefault();
        setSpinner(true);
        try {
            const response = await apiCall({
                url: `webhook/facebook/config`,
                method: 'POST',
                body: facebookWebhook
            });

            setAlertMessage({ message: response.msg, class: 'success' });

            if (response.success) {
                hideAlert(2)
            }

        } catch (error) {
            setAlertMessage({ message: error.message, class: 'danger' });
            hideAlert(2);
        }
    };

    const handleInstagramSubmit = async (e) => {
        e.preventDefault();
        setSpinner(true);
        try {
            const response = await apiCall({
                url: `webhook/instagram/config`,
                method: 'POST',
                body: instagramWebhook
            });

            setAlertMessage({ message: response.msg, class: 'success' });

            if (response.success) {
                hideAlert(2)
            }

        } catch (error) {
            setAlertMessage({ message: error.message, class: 'danger' });
            hideAlert(2);
        }
    };

    // hide alert after few seconds
    const hideAlert = (sec = 1) => {
        setTimeout(() => {
            setAlertMessage('');
            setSpinner(false);
        }, (sec * 1000));
    }

    useEffect(() => {
        document.title = "API Access"
        fetchWebookData();
    }, [])
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="card-title">
                        Facebook Massenger Webhook Config
                    </div>
                </div>
                <div className="card-body">
                    <div className='py-3'>
                        <div className="row">
                            <div className="col-md-6">
                                <form onSubmit={handleFacebookSubmit} className='border p-3'>

                                    <div className="form-group">
                                        <label htmlFor="">Webhook URL</label>
                                        <input type="text" className='form-control' placeholder='Webhook URL' value={`https://b7d7-223-123-42-188.ngrok-free.app/api/webhook/facebook/${facebookWebhook.access_token}`} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">Verify Access Token</label>
                                        <input type="text" className='form-control' placeholder='Verify Access Token' value={facebookWebhook.access_token} onChange={(e) => setFacebookWebhook({ ...facebookWebhook, access_token: e.target.value })} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">Page Access Token</label>
                                        <input type="text" className='form-control' placeholder='Page Access Token' value={facebookWebhook.page_access_token} onChange={(e) => setFacebookWebhook({ ...facebookWebhook, page_access_token: e.target.value })} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">App ID</label>
                                        <input type="text" className='form-control' placeholder='App ID' value={facebookWebhook.app_id} onChange={(e) => setFacebookWebhook({ ...facebookWebhook, app_id: e.target.value })} />
                                    </div>
                                    <button type="submit" className='btn btn-primary w-100'>
                                        Save Facebook Settings
                                    </button>
                                    <button type="button" onClick={syncFacebookConversationList} className='btn btn-success mt-3 w-100'>
                                        Sync Facebook Chats
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mt-2">
                <div className="card-header">
                    <div className="card-title">
                        Instagram Massenger Webhook Config
                    </div>
                </div>
                <div className="card-body">
                    <div className='py-3'>
                        <div className="row">
                            <div className="col-md-6">
                                <form onSubmit={handleInstagramSubmit} className='border p-3'>

                                    <div className="form-group">
                                        <label htmlFor="">Webhook URL</label>
                                        <input type="text" className='form-control' placeholder='Webhook URL' value={`https://b7d7-223-123-42-188.ngrok-free.app/api/webhook/instagram/${instagramWebhook.access_token}`} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">Verify Access Token</label>
                                        <input type="text" className='form-control' placeholder='Verify Access Token' value={instagramWebhook.access_token} onChange={(e) => setInstagramWebhook({ ...instagramWebhook, access_token: e.target.value })} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">Page Access Token</label>
                                        <input type="text" className='form-control' placeholder='Page Access Token' value={instagramWebhook.page_access_token} onChange={(e) => setInstagramWebhook({ ...instagramWebhook, page_access_token: e.target.value })} />
                                    </div>
                                    <div className="form-group my-3">
                                        <label htmlFor="">Page ID</label>
                                        <input type="text" className='form-control' placeholder='Page ID' value={instagramWebhook.app_id} onChange={(e) => setInstagramWebhook({ ...instagramWebhook, app_id: e.target.value })} />
                                    </div>
                                    <button type="submit" className='btn btn-primary w-100'>
                                        Save Instagram Settings
                                    </button>
                                    <button type="button" onClick={syncInstagramConversationList} className='btn btn-success mt-3 w-100'>
                                        Sync Instagram Chats
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>


    )
}

export default WebhookSettingLayer